var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEsgChatLogoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63923 3.58153C5.49972 3.33498 5.58151 3.0194 5.82205 2.87641C6.06258 2.73341 6.37048 2.81724 6.50999 3.06378L8.55696 6.6954L10.6039 10.327C10.7026 10.5021 10.6905 10.7141 10.5871 10.8719L8.55696 14.4739L6.50999 18.1055C6.37048 18.3521 6.06258 18.4359 5.82205 18.2929C5.58151 18.1499 5.49972 17.8343 5.63923 17.5878L7.68622 13.9562L9.58647 10.5834L7.68622 7.20821L5.63923 3.5766V3.58153Z",
    fill: "#705B27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1488 3.03549C17.4279 3.03549 17.654 2.80374 17.654 2.51775C17.654 2.23175 17.4279 2 17.1488 2H11.1594C10.8804 2 10.6543 2.23175 10.6543 2.51775C10.6543 2.80374 10.8804 3.03549 11.1594 3.03549H17.1488Z",
    fill: "#2B9C90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6618 5.72402C18.9432 5.72402 19.1693 5.4898 19.1693 5.20381C19.1693 4.91781 18.9408 4.68359 18.6618 4.68359H12.7085C12.427 4.68359 12.2009 4.91781 12.2009 5.20381C12.2009 5.4898 12.4294 5.72402 12.7085 5.72402H18.6618Z",
    fill: "#2B9C90"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.18 8.4144C20.459 8.4144 20.6851 8.18264 20.6851 7.89665C20.6851 7.61066 20.459 7.37891 20.18 7.37891H14.3854C14.1064 7.37891 13.8802 7.61066 13.8802 7.89665C13.8802 8.18264 14.1064 8.4144 14.3854 8.4144H20.18Z",
    fill: "#2B9C90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.695 11.1058C21.974 11.1058 22.2001 10.8741 22.2001 10.5881C22.2001 10.3021 21.974 10.0703 21.695 10.0703H15.7224C15.4434 10.0703 15.2173 10.3021 15.2173 10.5881C15.2173 10.8741 15.4434 11.1058 15.7224 11.1058H21.695Z",
    fill: "#2B9C90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1493 19.1761C17.4283 19.1761 17.6544 18.9444 17.6544 18.6584C17.6544 18.3724 17.4283 18.1406 17.1493 18.1406H11.2658C10.9867 18.1406 10.7606 18.3724 10.7606 18.6584C10.7606 18.9444 10.9867 19.1761 11.2658 19.1761H17.1493Z",
    fill: "#2B9C90"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6642 16.4867C18.9433 16.4867 19.1694 16.2549 19.1694 15.9689C19.1694 15.6829 18.9433 15.4512 18.6642 15.4512H12.7013C12.4223 15.4512 12.1962 15.6829 12.1962 15.9689C12.1962 16.2549 12.4223 16.4867 12.7013 16.4867H18.6642Z",
    fill: "#2B9C90"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1799 13.7953C20.4589 13.7953 20.685 13.5635 20.685 13.2775C20.685 12.9915 20.4589 12.7598 20.1799 12.7598H14.3012C14.0221 12.7598 13.796 12.9915 13.796 13.2775C13.796 13.5635 14.0221 13.7953 14.3012 13.7953H20.1799Z",
    fill: "#2B9C90"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3741 5.81981C4.23459 5.57326 4.31637 5.25769 4.5569 5.11469C4.79744 4.97169 5.10533 5.05552 5.24485 5.30206L6.66161 7.81683L8.07838 10.3316C8.17701 10.5066 8.16498 10.7162 8.06155 10.8765L6.66161 13.3616L5.24485 15.8764C5.10533 16.123 4.79744 16.2068 4.5569 16.0638C4.31637 15.9208 4.23459 15.6052 4.3741 15.3587L5.79086 12.8439L7.06091 10.588L5.79086 8.33211L4.3741 5.81734V5.81981Z",
    fill: "#705B27"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.06807 8.15575C2.92855 7.9092 3.01034 7.59362 3.25088 7.45063C3.49142 7.30763 3.79931 7.39146 3.93882 7.638L5.45421 10.3278C5.55283 10.5029 5.5408 10.7124 5.43737 10.8727L3.93882 13.5354C3.80172 13.7819 3.49382 13.8657 3.25329 13.7252C3.01275 13.5847 2.93096 13.2691 3.06807 13.0226L4.43914 10.5892L3.06807 8.15575Z",
    fill: "#FAB900"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63423 2.00391H9.46649C9.7407 2.00391 9.96681 2.23319 9.96681 2.51672C9.96681 2.79778 9.74311 3.02954 9.46649 3.02954H8.63423C8.36001 3.02954 8.13391 2.80025 8.13391 2.51672C8.13391 2.23566 8.35761 2.00391 8.63423 2.00391Z",
    fill: "#2B9C90"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1836 4.69922H11.0158C11.29 4.69922 11.5161 4.92851 11.5161 5.21203C11.5161 5.4931 11.29 5.72485 11.0158 5.72485H10.1836C9.90934 5.72485 9.68323 5.49556 9.68323 5.21203C9.68323 4.93097 9.90693 4.69922 10.1836 4.69922Z",
    fill: "#2B9C90"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8595 7.38867H12.6917C12.9659 7.38867 13.192 7.61796 13.192 7.90149C13.192 8.18255 12.9659 8.4143 12.6917 8.4143H11.8595C11.5852 8.4143 11.3591 8.18501 11.3591 7.90149C11.3591 7.62043 11.5828 7.38867 11.8595 7.38867Z",
    fill: "#2B9C90"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1971 10.0781H14.0294C14.3036 10.0781 14.5297 10.3074 14.5297 10.5909C14.5297 10.872 14.3036 11.1038 14.0294 11.1038H13.1971C12.9229 11.1038 12.6968 10.8745 12.6968 10.5909C12.6968 10.3099 12.9205 10.0781 13.1971 10.0781Z",
    fill: "#2B9C90"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7751 12.7656H12.6074C12.8816 12.7656 13.1077 12.9949 13.1077 13.2784C13.1077 13.5595 12.8816 13.7913 12.6074 13.7913H11.7751C11.5009 13.7913 11.2748 13.562 11.2748 13.2784C11.2748 12.9974 11.4985 12.7656 11.7751 12.7656Z",
    fill: "#2B9C90"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1759 15.4551H11.0081C11.2823 15.4551 11.5084 15.6844 11.5084 15.9679C11.5084 16.249 11.2823 16.4807 11.0081 16.4807H10.1759C9.90165 16.4807 9.67554 16.2514 9.67554 15.9679C9.67554 15.6868 9.89924 15.4551 10.1759 15.4551Z",
    fill: "#2B9C90"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73983 18.1445H9.57209C9.8463 18.1445 10.0724 18.3738 10.0724 18.6573C10.0724 18.9384 9.8463 19.1702 9.57209 19.1702H8.73983C8.46561 19.1702 8.2395 18.9409 8.2395 18.6573C8.2395 18.3763 8.46321 18.1445 8.73983 18.1445Z",
    fill: "#2B9C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsgChatLogoIcon);
export default __webpack_public_path__ + "static/media/ESG-Chat-logo-icon.1af53139eb8e545030eed988e77dcbec.svg";
export { ForwardRef as ReactComponent };